<template>
  <div class="container-network">
    <div class="container-fluid">
      <div class="card">
        <div class="flex-jus-spa-bet">
          <a
            class="btn__new__cicle"
            @click="createElLead(5, true)"
            v-html="translation.generate_new_cycle"
          ></a>
          <a
            v-if="this.$parent.$parent.view.all_offline_leads.length != 0"
            class="btn__recover__cicle"
            @click="handleModalOfflineLeads"
            v-html="translation.recover_leads"
          ></a>
        </div>
        <div class="network" v-bind:class="[noShowGrandson ? 'no-fixed-height' : '']">
          <div class="card__leader" v-for="(lead, index) in this.leads" :key="index">
            <div class="leader__info" v-bind:class="[lead.franchise_network == 1 ? 'active' : '']">
              <div
                class="lead__delete"
                @click="handleChallengeLead(index, lead.id_usuario, 0)"
                v-bind:class="{ 'loading__delete': loading}"
              ></div>
              <div class="lead__create__link">
                <input
                  class="name__leader js-name__leader"
                  v-if="lead.franchise_network != 1"
                  type="text"
                  :value="decodeHTMLEntities(translation.leader)+' '+(index + 1)"
                  @click="$event.target.select()"
                  @input="handleLeadLink"
                  :maxlength="15"
                >
                <!-- <h2
                  contenteditable="true"
                  @input="handleLeadLink"
                  v-if="lead.franchise_network != 1"
                >{{translation.leader}} {{index + 1}}</h2>-->
                <span
                  class="display-none-imp create__link js-btn__create"
                  @click="handleCreateLeadLink"
                ></span>
                <span
                  v-if="lead.franchise_network != 1"
                  class="video__create_link js-video__create_link"
                  @click="handleVideoLink"
                ></span>
              </div>
              <h2 v-if="lead.franchise_network == 1">{{lead.nome}}</h2>
              <div v-if="lead.franchise_network == 1">
                <br>
                <br>
                <br>
              </div>
              <div
                class="opacity-zero transition-5 js-link__done"
                v-bind:class="[lead.franchise_network == 1 ? 'display-none-imp' : '']"
              >
                <input class="input" type="text" :id="['link__created__share_' + index]">
                <div
                  class="copy__link copy"
                  :data-clipboard-target="['#link__created__share_' + index]"
                  v-bind:class="[lead.franchise_network != 1 ? 'display-none1' : '']"
                >
                  <i class="fa fa-cut"></i>
                  {{translation.copy_link}}
                </div>
              </div>
              <!-- <h3>{{lead.nome}}</h3> -->
              <span
                class="copy"
                :data-clipboard-target="['#general-share-link-lead-' + index]"
                :data-labelCopy="translation.copied"
              >
                <i class="fa fa-cut"></i>
                {{translation.copy_link}}
              </span>
            </div>
            <div class="leads__info" v-if="!noShowGrandson">
              <div
                class="card__lead"
                v-for="(subLead, index) in lead.grandsons"
                v-bind:class="[subLead.franchise_network == 1 ? 'active' : '']"
                :key="index"
              >{{subLead.nome}}</div>
            </div>
            <input
              v-if="lead.id_usuario"
              class="input__share__link__lead"
              type="text"
              :value="handleShareLead(lead.id_usuario)"
              :id="['general-share-link-lead-' + index]"
            >
            <input
              v-if="!lead.id_usuario"
              class="input__share__link__lead"
              type="text"
              :value="linkUserData"
              :id="['general-share-link-lead-' + index]"
            >
            <div
              class="copy__link copy"
              :data-clipboard-target="['#general-share-link-lead-' + index]"
              v-bind:class="[lead.franchise_network != 1 ? 'display-none1' : '']"
              v-if="!noShowGrandson"
              :data-labelCopy="translation.copied"
            >
              <i class="fa fa-cut"></i>
              {{translation.copy_link}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modalShow"
      class="modal fade in"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="false"
      style="display: block; position: relative;"
	  id="modal_how_to_insert_leads"
    >
      <div
        class="modal-dialog"
        role="document"
        style="position: fixed; top: 20%; left: 0; right: 0;"
      >
        <div class="modal-content" style="position: fixed;">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="modalShow = !modalShow"
            >
              <span
                aria-hidden="true"
                style="font-size: 30px; position: absolute; right: 11px; top: 2px;"
              >×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="video-principal">
                <iframe
                  id="modal-video"
                  :src="`https://www.youtube.com/embed/`+videoHowToCreate"
                  class="lazyload modal-video"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                ></iframe>
              </div>
            </div>

            <div class="row thumbs">
              <div class="flex-container-thumb scroll"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modalShowLeads && this.$parent.$parent.view.all_offline_leads.length != 0"
      class="modal fade in"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="false"
      style="display: block; position: relative;"
    >
      <div
        class="modal-dialog"
        role="document"
        style="position: fixed; top: 300px; left: 0; right: 0;"
      >
        <div class="modal-content" style="position: fixed;" id="modal_recover_leads">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="modalShowLeads = !modalShowLeads"
            >
              <span
                aria-hidden="true"
                style="font-size: 30px; position: absolute; right: 11px; top: 2px;"
              >×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row modal__recover">
              <div class="col-sm-12">
                <h2>{{translation.label_click_recover_leads}}</h2>
              </div>
              <div class="col-sm-12">
                <div class="flex-jus-spa-bet cursor__pointer recover__select__lead"
                     v-for="(lead, index) in this.$parent.$parent.view.all_offline_leads"
                     :key="index"
                     @click="handleChallengeLead(index, lead.id_usuario, 1)">
                  <b>{{lead.nome}}</b>
                  <span class="ico__recover__modal"></span>
                </div>
              </div>
            </div>

            <div class="row thumbs">
              <div class="flex-container-thumb scroll"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "network-user",
  props: [
    "props",
    "stepOneProp",
    "stepTwoProp",
    "linkUser",
    "minimumLeads",
    "buttonCycle",
    "funnel"
  ],
  components: {},
  data() {
    var translation = {};
    if (this.$parent.$parent.view.translation.networkUser) {
      translation = this.$parent.$parent.view.translation.networkUser;
    }

    return {
      leads: {},
      nome: null,
      loading: false,
      stepOne: false,
      stepTwo: false,
      translation: translation,
      linkUserData: null,
      showBtnCycle: false,
      modalShow: false,
      modalShowLeads: false,
      videoHowToCreate: this.$parent.$parent.view.videos.how_to_create_link,
      noShowGrandson: false
    };
  },
  methods: {
    decodeHTMLEntities(str) {
      var element = document.createElement("div");

      if (str && typeof str === "string") {
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = "";
      }

      return str;
    },
    handleLeadList(totalLeadsToAdd) {
      this.nome = this.translation.name;
      let cicles = this.$parent.$parent.view.dados_usuario_office
        .franchise_step_cicles;
      let totalItems = cicles * 5;
      let totalItemsToAdd = this.leads.length;

      //se vier um array zerado (sem leads), preenche com 5 mookups
      if (this.leads.length == 0) {
        this.leads = [];
        this.createElLead(totalLeadsToAdd);
        //this.leads[0].franchise_network = 0;
      }

      // adiciona o restante para o ciclo fechar
      // if (totalItemsToAdd < totalItems) {
      this.createElLead(totalItems - totalItemsToAdd);
      // }

      // pra cada linhas precisa ser um divisivel de 5
      if (totalItemsToAdd % 5 != 0) {
        //pega a quantidade de leads que deve adicionar na tabela
        let totalItemsToAdd = 5 - (this.leads.length % 5);
        this.createElLead(totalItemsToAdd);
      }
    },
    createNewCicle(newCycles, totalItemsToAdd) {
      const BASE_URI = `${window.location.origin}${window.location.pathname}`;
      axios
        .post(`${BASE_URI}/update-step-cicle/${newCycles}`, {})
        .then(response => {
          if (response.status == 200) {
            for (let i = 0; i < totalItemsToAdd; i++) {
              this.leads.push({
                nome: this.nome,
                id_usuario: null,
                id_usuario_pai: null,
                grandsons: [],
                franchise_network: 0
              });
            }
            this.handleSubLeadsList();
          }
        })
        .catch(error => {
          console.log("erro", error, error.response);
        });
    },
    createElLead(totalItemsToAdd, newCicle) {
      let cicles = this.$parent.$parent.view.dados_usuario_office
        .franchise_step_cicles;

      // console.log(this.leads);
      if (newCicle) {
        this.createNewCicle(parseInt(cicles) + 1, totalItemsToAdd);
      } else {
        //preenche as lacunas que faltam com arquivos de mookup
        for (let i = 0; i < totalItemsToAdd; i++) {
          this.leads[this.leads.length] = {
            nome: this.nome,
            id_usuario: null,
            id_usuario_pai: null,
            grandsons: [],
            franchise_network: 0
          };
        }
        this.handleSubLeadsList();
      }
    },
    handleShareLead(leadId) {
      return `${this.funnel}#aid=${leadId}`;
    },
    handleSubLeadsList() {
      this.nome = this.translation.name;

      this.leads.forEach(lead => {
        //verifica se os subleads da pessoa ja existe 5, se nao completa com mookups
        if (lead.grandsons.length < 5) {
          let totalItems = 5 - lead.grandsons.length;
          for (let i = 0; i < totalItems; i++) {
            lead.grandsons[lead.grandsons.length] = {
              nome: this.nome,
              id_usuario: null,
              id_usuario_pai: null,
              grandsons: [],
              franchise_network: 0
            };
          }
        }
        if (lead.grandsons.length > 5) {
          lead.grandsons = lead.grandsons.slice(0, 5);
        }
      });
    },
    handleChallengeLead(index, lead, visible) {
      if(visible == 0) if (!confirm(this.translation.delete)) return;
      this.loading = true;

      const BASE_URI = `${window.location.origin}${window.location.pathname}`;

      axios
        .post(`${BASE_URI}/handle-lead-graphic`, {
          visibility: visible,
          id_son: lead
        })
        .then(response => {
          if (response.data.msg == "success") {
            this.$parent.$parent.view.all_leads = response.data.leads_online;
            this.$parent.$parent.view.all_offline_leads = response.data.leads_offline;
            this.leads = response.data.leads_online;
            // this.leads.splice(index, 1);
            this.handleLeadList();
            // if (this.stepOneProp) {
            //   this.leads = this.leads.slice(0, 5);
            // }
            this.loading = false;
            if(this.$parent.$parent.view.all_offline_leads.length == 0) this.modalShowLeads = false;
          }
        })
        .catch(error => {
          console.log("erro", error, error.response);
        });
    },
    handleLeadLink(event) {
      // let oldText = event.target.innerText;
      //se o campo estiver sem nada insere um traco
      if (event.target.innerText.length == 0) {
        // event.target.value = "-";
        event.target.parentNode
          .querySelector(".js-btn__create")
          .classList.add("display-none-imp");
        event.target.parentNode
          .querySelector(".js-video__create_link")
          .classList.remove("display-none-imp");
      }
      event.target.classList.add("create__link");
      //para nao enviar um link em branco
      if (event.target.value.length > 0) {
        event.target.parentNode
          .querySelector(".js-video__create_link")
          .classList.add("display-none-imp");
        //sobe uma div e tira a ocultacao do botao de gerar o link
        event.target.parentNode
          .querySelector(".js-btn__create")
          .classList.remove("display-none-imp");
      }
    },
    createFunnelLink(name, { userId }) {
      const encodedName = btoa(name);

      return `${this.funnel}#aid=${userId}&name=${encodedName}`;
    },
    handleCreateLeadLink(event) {
      //sobe 2 div para pegar a div que engloba o inpu e o botao de copiar para exibir ela
      let divLink = event.target.parentNode.parentNode.querySelector(
        ".js-link__done"
      );
      divLink.classList.remove("opacity-zero");
      this.loading = true;

      let name = event.target.parentNode.querySelector(".js-name__leader")
        .value;

      divLink.querySelector("input").value = this.createFunnelLink(
        name,
        window.__env
      );
    },
    handleVideoLink() {
      this.modalShow = true;
    },
    handleModalOfflineLeads() {
			if(!this.modalShowLeads) {
				this.modalShowLeads = true;

				setTimeout(() => {
					var testDiv = document.querySelector("#modal_recover_leads");
					var rect = testDiv.getBoundingClientRect();
					window.scrollTo(0, 300);
				}, 800);
			}
    }

  },
  created() {
    if (this.stepOneProp) {
      this.stepOne = this.stepOneProp;
    }
    if (this.stepTwoProp) {
      this.stepTwo = this.stepTwoProp;
    }
    if (this.buttonCycle == true) {
      this.showBtnCycle = true;
    }
    // console.log(this.buttonCycle);

    // this.leads = this.props;
    this.leads = this.$parent.$parent.view.all_leads;

    this.linkUserData = this.linkUser;
    // console.log(this.leads);
    this.handleLeadList();
  },
  mounted() {
    //se tiver no passo 1 vai mostrar somente 5 elementos independente de quantos tiver
    // if (this.stepOne) {
    //   this.leads = this.leads.slice(0, 5);
    // }
    if (this.stepOne || this.stepTwo) {
      this.noShowGrandson = true;
    }
    if (this.stepTwo || this.$parent.$parent.view.v1_funnel_challenge) {
      this.noShowGrandson = false;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container-network {
  margin-left: 25px;
  margin-right: 25px;
  .container-fluid {
    padding-right: 0px;
    padding-left: 0px;
  }
  .card {
    margin-top: 25px;
    padding: 1rem;
  }
}
.btn__recover__cicle,
.btn__new__cicle {
  background: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNjQgODAiIHg9IjBweCIgeT0iMHB4Ij48cGF0aCBkPSJNMzIgNjRDMTQuNCA2NCAwIDQ5LjYgMCAzMlMxNC40IDAgMzIgMHMzMiAxNC40IDMyIDMyLTE0LjQgMzItMzIgMzJ6bTAtNjBDMTYuNiA0IDQgMTYuNiA0IDMyczEyLjYgMjggMjggMjggMjgtMTIuNiAyOC0yOFM0Ny40IDQgMzIgNHptMiA0M1YxN2MwLTEuMS0uOS0yLTItMnMtMiAuOS0yIDJ2MzBjMCAxLjEuOSAyIDIgMnMyLS45IDItMnptMTUtMTVjMC0xLjEtLjktMi0yLTJIMTdjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyaDMwYzEuMSAwIDItLjkgMi0yeiIvPjwvc3ZnPg==);
  background-repeat: no-repeat;
  background-position-y: 8px;
  background-size: 20px;
  background-position-x: 5px;
  display: block;
  width: 200px;
  margin-bottom: 1rem;
  background-color: #0294ff;
  color: white;
  padding: 0.6rem 1.4rem;
  font-weight: 700;
  border-radius: 4px;
  -webkit-transition: 0.3s all;
  transition: 0.3s all;
  text-align: center;
  margin-right: 12px;
  cursor: pointer;
  margin-left: 1rem;
  &:hover {
    background-color: #30a9ff;
  }
}
.btn__recover__cicle {
  background-image: none;
}
.network {
  justify-content: space-between;
  flex-flow: wrap;
  display: flex;
  // min-height: 400px;
  // max-height: 80vh;
  // overflow-y: auto;
  &.no-fixed-height {
    min-height: unset;
    .card__leader {
      margin-bottom: 0;
      min-width: 85px;
    }
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #0294ff;
  }
  .card__leader {
    width: calc(20%);
    padding: 0 5px;
    margin-bottom: 32px;
    min-width: 85px;
    // display: flex;
  }
  .leader__info {
    // width: 200px;
    text-align: center;
    border-radius: 7px;
    padding: 10px 5px 5px 10px;
    background: #f8fafd;
    color: #818a91;
    position: relative;
    height: 110px;
    margin-bottom: 1.8rem;
    min-width: 85px;
    &::after {
      content: "";
      background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1mZWNoYWR1cmEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEyLjgyOCAxNy4xMDUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICM4MThhOTE7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJHcm91cF80MjMiIGRhdGEtbmFtZT0iR3JvdXAgNDIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xMiIgZGF0YS1uYW1lPSJQYXRoIDEyIiBjbGFzcz0iY2xzLTEiIGQ9Ik03Ni40NzIsNi40MTRINzUuNFY0Ljk4OWE0Ljk4OSw0Ljk4OSwwLDEsMC05Ljk3OCwwVjYuNDE0SDY0LjM1NkEuMzU2LjM1NiwwLDAsMCw2NCw2Ljc3MXY4LjkwOUExLjQyNywxLjQyNywwLDAsMCw2NS40MjUsMTcuMUg3NS40YTEuNDI3LDEuNDI3LDAsMCwwLDEuNDI1LTEuNDI1VjYuNzcxQS4zNTYuMzU2LDAsMCwwLDc2LjQ3Miw2LjQxNFptLTQuOTkxLDcuNDQ0YS4zNTYuMzU2LDAsMCwxLS4zNTQuNEg2OS43YS4zNTYuMzU2LDAsMCwxLS4zNTQtLjRsLjIyNS0yLjAyMWExLjQxLDEuNDEsMCwwLDEtLjU4My0xLjE0NiwxLjQyNSwxLjQyNSwwLDEsMSwyLjg1MSwwLDEuNDEsMS40MSwwLDAsMS0uNTgzLDEuMTQ2Wm0xLjc4NC03LjQ0NGgtNS43VjQuOTg5YTIuODUxLDIuODUxLDAsMSwxLDUuNywwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY0KSIvPgogIDwvZz4KPC9zdmc+);
      position: absolute;
      width: 18px;
      height: 24px;
      top: 4px;
      left: 4px;
    }
    span {
      margin: 0;
      display: none;
    }
    h3 {
      display: none;
      font-weight: 700;
    }
    h2 {
      font-size: 1.35rem;
      font-weight: 700;
      display: -webkit-box !important;
      padding: 0 15px;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    input.name__leader {
      text-align: center;
      font-size: 1.1rem;
      color: #818a91;
      width: 80%;
      margin: 0 auto;
      max-height: 25px;
      overflow: hidden;
      border: 0;
      background: transparent;
    }
    .lead__create__link {
      position: relative;
      .create__link {
        // white-space: nowrap;
        // overflow: hidden !important;
        // text-overflow: ellipsis;
        width: 80%;
        margin: 0 auto;
        max-height: 25px;
        overflow: hidden;
      }
      span.create__link {
        position: absolute;
        right: -5px;
        top: -1px;
        background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDY0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgZmlsbD0iIzAyOTRmZiI+PGc+PHBhdGggZD0iTTMwOC42LDI3Mi43Yy05LjktOS45LTI2LTkuOS0zNS45LDBjLTI5LjcsMjkuNy03OC4xLDI5LjctMTA3LjgsMGwtODkuOC04OS44Yy0xNC40LTE0LjQtMjIuMy0zMy41LTIyLjMtNTMuOSAgIGMwLTIwLjQsNy45LTM5LjUsMjIuMy01My45YzI5LjctMjkuNyw3OC0yOS43LDEwNy44LDBsNTUuMiw1NS4yYzkuOSw5LjksMjYsOS45LDM1LjksMGM5LjktOS45LDkuOS0yNiwwLTM1LjlsLTU1LjItNTUuMiAgIGMtNDkuNS00OS41LTEzMC4xLTQ5LjUtMTc5LjYsMEMxNS4yLDYzLjIsMiw5NSwyLDEyOWMwLDMzLjksMTMuMiw2NS44LDM3LjIsODkuOGw4OS44LDg5LjhjMjQuOCwyNC43LDU3LjMsMzcuMSw4OS44LDM3LjEgICBjMzIuNSwwLDY1LTEyLjQsODkuOC0zNy4xQzMxOC41LDI5OC43LDMxOC41LDI4Mi42LDMwOC42LDI3Mi43eiIvPjxwYXRoIGQ9Ik00NzIuOCwyOTMuMkwzODMsMjAzLjRjLTQ5LjUtNDkuNS0xMzAuMS00OS41LTE3OS42LDBjLTkuOSw5LjktOS45LDI2LDAsMzUuOWM5LjksOS45LDI2LDkuOSwzNS45LDAgICBjMjkuNy0yOS43LDc4LTI5LjcsMTA3LjgsMGw4OS44LDg5LjhjMTQuNCwxNC40LDIyLjMsMzMuNSwyMi4zLDUzLjljMCwyMC40LTcuOSwzOS41LTIyLjMsNTMuOWMtMjguOCwyOC44LTc5LDI4LjgtMTA3LjgsMCAgIEwyNzQsMzgxLjdjLTkuOS05LjktMjYtOS45LTM1LjksMGMtOS45LDkuOS05LjksMjYsMCwzNS45bDU1LjIsNTUuMWMyNCwyNCw1NS45LDM3LjIsODkuOCwzNy4yYzMzLjksMCw2NS44LTEzLjIsODkuOC0zNy4yICAgYzI0LTI0LDM3LjItNTUuOSwzNy4yLTg5LjhDNTEwLDM0OSw0OTYuOCwzMTcuMiw0NzIuOCwyOTMuMnoiLz48cGF0aCBkPSJNMTI5LDQwOC40aC0yNS40VjM4M2MwLTE0LTExLjQtMjUuNC0yNS40LTI1LjRjLTE0LDAtMjUuNCwxMS40LTI1LjQsMjUuNHYyNS40SDI3LjRjLTE0LDAtMjUuNCwxMS40LTI1LjQsMjUuNCAgIGMwLDE0LDExLjQsMjUuNCwyNS40LDI1LjRoMjUuNHYyNS40YzAsMTQsMTEuNCwyNS40LDI1LjQsMjUuNGMxNCwwLDI1LjQtMTEuNCwyNS40LTI1LjR2LTI1LjRIMTI5YzE0LDAsMjUuNC0xMS40LDI1LjQtMjUuNCAgIEMxNTQuNCw0MTkuNywxNDMsNDA4LjQsMTI5LDQwOC40eiIvPjwvZz48L3N2Zz4=);
        background-repeat: no-repeat;
        background-size: 18px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        display: block;
      }
      span.video__create_link {
        position: absolute;
        right: -5px;
        top: -8px;
        background: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDI5NGZmIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTYgMjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTYuNTI0LDQuNzY2QzYuNDA5LDQuNjg4LDYuMjYsNC42OCw2LjEzOCw0Ljc0M2MtMC4xMjMsMC4wNjUtMC4yLDAuMTkzLTAuMiwwLjMzMnY1Ljg1YzAsMC4xMzksMC4wNzcsMC4yNjcsMC4yLDAuMzMyICBDNi4xOTIsMTEuMjg1LDYuMjUyLDExLjMsNi4zMTMsMTEuM2MwLjA3NCwwLDAuMTQ4LTAuMDIyLDAuMjEyLTAuMDY1TDEwLjgsOC4zMWMwLjEwMi0wLjA3LDAuMTYzLTAuMTg2LDAuMTYzLTAuMzEgIFMxMC45MDEsNy43NjEsMTAuOCw3LjY5TDYuNTI0LDQuNzY2eiBNNi42ODgsMTAuMjE0VjUuNzg2TDkuOTI0LDhMNi42ODgsMTAuMjE0eiIvPjxwYXRoIGQ9Ik04LDEuNzc1QzQuNTY3LDEuNzc1LDEuNzc1LDQuNTY3LDEuNzc1LDhTNC41NjcsMTQuMjI1LDgsMTQuMjI1UzE0LjIyNSwxMS40MzMsMTQuMjI1LDhTMTEuNDMzLDEuNzc1LDgsMS43NzV6IE04LDEzLjQ3NSAgYy0zLjAxOSwwLTUuNDc1LTIuNDU2LTUuNDc1LTUuNDc1UzQuOTgxLDIuNTI1LDgsMi41MjVjMy4wMTksMCw1LjQ3NSwyLjQ1Niw1LjQ3NSw1LjQ3NVMxMS4wMTksMTMuNDc1LDgsMTMuNDc1eiIvPjwvc3ZnPg==);
        background-repeat: no-repeat;
        background-size: 30px;
        width: 30px;
        height: 30px;
        cursor: pointer;
        display: block;
        z-index: 1;
      }
    }
    // .copy{
    //   position: absolute;
    //   font-size: 11pt !important;
    //   font-weight: 200;
    //   left: 25%;
    //   bottom: 5px;
    //   transform: translateX(-10%);
    // }
    &.active {
      background: #0294ff;
      color: white;
      transition: 0.3s all;
      &::after {
        background: none;
      }
      &:hover {
        background: #ff5e5e;
        .lead__delete {
          background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxNi44NjUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJpY29uLWxpeGVpcmEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNi45KSI+CiAgICA8ZyBpZD0iR3JvdXBfNjY1IiBkYXRhLW5hbWU9Ikdyb3VwIDY2NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjYuOSkiPgogICAgICA8cGF0aCBpZD0iUGF0aF82OTgiIGRhdGEtbmFtZT0iUGF0aCA2OTgiIGNsYXNzPSJjbHMtMSIgZD0iTTQxLjQzMiwyLjQyN0gzNy45MjNWMS44NTVBMS44NTcsMS44NTcsMCwwLDAsMzYuMDY4LDBIMzIuNzMyYTEuODU3LDEuODU3LDAsMCwwLTEuODU1LDEuODU1di41NzJIMjcuMzY4YS40NjguNDY4LDAsMSwwLDAsLjkzNmguODQ2djExYTIuNTA3LDIuNTA3LDAsMCwwLDIuNSwyLjVoNy4zNjVhMi41MDcsMi41MDcsMCwwLDAsMi41LTIuNXYtMTFoLjg0NmEuNDY4LjQ2OCwwLDAsMCwwLS45MzZabS05LjYxOS0uNTcyYS45Mi45MiwwLDAsMSwuOTE5LS45MTloMy4zMzZhLjkyLjkyLDAsMCwxLC45MTkuOTE5di41NzJIMzEuODEzWk0zOS42NSwxNC4zNjJhMS41NywxLjU3LDAsMCwxLTEuNTY3LDEuNTY3SDMwLjcxOGExLjU3LDEuNTcsMCwwLDEtMS41NjctMS41Njd2LTExaDEwLjV2MTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjYuOSkiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfNjk5IiBkYXRhLW5hbWU9IlBhdGggNjk5IiBjbGFzcz0iY2xzLTEiIGQ9Ik0yMzAuMTY4LDE1NC42MDlhLjQ2Ni40NjYsMCwwLDAsLjQ2OC0uNDY4di04LjI3M2EuNDY4LjQ2OCwwLDAsMC0uOTM2LDB2OC4yN0EuNDY5LjQ2OSwwLDAsMCwyMzAuMTY4LDE1NC42MDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjY2OCAtMTQwLjM1OCkiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfNzAwIiBkYXRhLW5hbWU9IlBhdGggNzAwIiBjbGFzcz0iY2xzLTEiIGQ9Ik0xNDIuMDY4LDE2OC4zOGEuNDY2LjQ2NiwwLDAsMCwuNDY4LS40Njh2LTcuMjQzYS40NjguNDY4LDAsMSwwLS45MzYsMHY3LjI0M0EuNDY4LjQ2OCwwLDAsMCwxNDIuMDY4LDE2OC4zOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzcuNjIzIC0xNTQuNjQ1KSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF83MDEiIGRhdGEtbmFtZT0iUGF0aCA3MDEiIGNsYXNzPSJjbHMtMSIgZD0iTTMxOC4yNjgsMTY4LjM4YS40NjYuNDY2LDAsMCwwLC40NjgtLjQ2OHYtNy4yNDNhLjQ2OC40NjgsMCwwLDAtLjkzNiwwdjcuMjQzQS40NjYuNDY2LDAsMCwwLDMxOC4yNjgsMTY4LjM4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMwNy43MTMgLTE1NC42NDUpIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4=);
          width: 17px;
          height: 19px;
          right: 5px;
          position: absolute;
          left: unset;
          transition: 0.3s all;
          cursor: pointer;
          &.loading__delete {
            background: none;
            height: 23px;
            width: 23px;
            border-radius: 100%;
            border: 2px solid #0294ff;
            border-top-color: white;
            border-bottom-color: white;
            animation: rotation 1s linear infinite;
          }

          @keyframes rotation {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        }
      }
      .locker {
        display: none;
      }
      span,
      h3,
      h2 {
        margin: 0;
        display: block;
      }
      h3 {
        margin: 0.8rem 0;
      }
      h2 {
        font-size: 1.1rem;
        overflow: hidden;
      }
    }
  }
  .leads__info {
    text-align: center;
    .card__lead {
      background: #f8fafd;
      color: #818a91;
      padding: 1.2rem 2.2rem;
      border-radius: 7px;
      text-align: center;
      margin: 0 0.1rem;
      font-weight: 700;
      font-size: 0.78rem;
      max-width: 15ch;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;
      &::after {
        content: "";
        background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1mZWNoYWR1cmEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEyLjgyOCAxNy4xMDUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICM4MThhOTE7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJHcm91cF80MjMiIGRhdGEtbmFtZT0iR3JvdXAgNDIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xMiIgZGF0YS1uYW1lPSJQYXRoIDEyIiBjbGFzcz0iY2xzLTEiIGQ9Ik03Ni40NzIsNi40MTRINzUuNFY0Ljk4OWE0Ljk4OSw0Ljk4OSwwLDEsMC05Ljk3OCwwVjYuNDE0SDY0LjM1NkEuMzU2LjM1NiwwLDAsMCw2NCw2Ljc3MXY4LjkwOUExLjQyNywxLjQyNywwLDAsMCw2NS40MjUsMTcuMUg3NS40YTEuNDI3LDEuNDI3LDAsMCwwLDEuNDI1LTEuNDI1VjYuNzcxQS4zNTYuMzU2LDAsMCwwLDc2LjQ3Miw2LjQxNFptLTQuOTkxLDcuNDQ0YS4zNTYuMzU2LDAsMCwxLS4zNTQuNEg2OS43YS4zNTYuMzU2LDAsMCwxLS4zNTQtLjRsLjIyNS0yLjAyMWExLjQxLDEuNDEsMCwwLDEtLjU4My0xLjE0NiwxLjQyNSwxLjQyNSwwLDEsMSwyLjg1MSwwLDEuNDEsMS40MSwwLDAsMS0uNTgzLDEuMTQ2Wm0xLjc4NC03LjQ0NGgtNS43VjQuOTg5YTIuODUxLDIuODUxLDAsMSwxLDUuNywwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY0KSIvPgogIDwvZz4KPC9zdmc+);
        position: absolute;
        width: 10px;
        height: 13px;
        top: 5px;
        left: 5px;
      }
      &:nth-child(1) {
        display: inline-block;
      }
      &:nth-child(2) {
        display: inline-block;
      }
      &:nth-child(3) {
        display: block;
        margin: 0.7rem auto;
        width: 50%;
      }
      &:nth-child(4) {
        display: inline-block;
      }
      &:nth-child(5) {
        display: inline-block;
      }
      &.active {
        background: #0294ff;
        color: white;
        &::after {
          background: none;
        }
        .locker {
          display: none;
        }
      }
    }
  }

  .h1,
  .h2,
  .h3,
  h1,
  h2,
  h3 {
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
.modal__recover {
  h2 {
    margin-top: 0;
    font-weight: 900;
    text-align: center;
  }
  .recover__select__lead {
    transition: .3s all;
    padding: .4rem 1rem;
    &:hover {
      border-radius: 3px;
      background: gainsboro;
    }
  }
}
.flex-jus-spa-bet {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cursor__pointer {
  cursor: pointer;
}
.input__share__link__lead {
  opacity: 0;
  // height: 0;
  // width: 0;
}
.copy__link {
  // position: relative;
  text-align: center;
  cursor: pointer;
  margin-left: 3px;
  color: #818a91;
  font-weight: 100;
  margin-top: 1rem;
}
.display-none {
  display: none;
}
.display-none-imp {
  display: none !important;
}
.no-margin {
  margin: 0;
}
.opacity-zero {
  opacity: 0;
}
.transition-5 {
  transition: 0.5s all;
}
.modal-body {
  min-width: 280px;
}
.input {
  color: #3d3d3d;
  border-radius: 6px;
  border: none;
  height: 30px;
  transition: 0.3s all;
  border: 1px solid #007aff;
  &:focus {
    outline: none;
  }
  &:hover {
    -webkit-box-shadow: 0px 10px 23px 0px #cad1d7;
    -moz-box-shadow: 0px 10px 23px 0px #cad1d7;
    box-shadow: 0px 10px 23px 0px #cad1d7;
    outline: none;
  }
}
.ico__recover__modal {
  background-image: url(data:image/svg+xml;base64,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);
  width: 23px;
  height: 29px;
  display: block;
}
@media (max-width: 1600px) {
  .network .leads__info .card__lead,
  .network .leads__info .card__lead.active {
    padding: 1rem;
  }
}
@media (max-width: 1580px) {
  .network .leader__info input.name__leader {
    font-size: 1rem;
  }
}
@media (max-width: 1500px) {
  .network .leads__info .card__lead {
    max-width: 10ch;
  }
  .network .leader__info::after {
    width: 14px;
    height: 19px;
    top: 9px;
    left: 3px;
  }

  .network .leader__info input.name__leader {
    font-size: 1rem;
    width: 90%;
  }
}
@media (max-width: 1400px) {
  .network .leader__info.active h2 {
    font-size: 1rem;
  }
}
@media (max-width: 1350px) {
  .card {
    padding: 1rem 0;
  }
}
@media only screen and (max-width: 1350px) {
  .network .card__leader {
    width: calc(25%);
  }
}
@media only screen and (max-width: 1250px) {
  .network .card__leader {
    width: calc(33%);
  }
}
@media only screen and (max-width: 992px) {
  .network {
    .card__leader {
      min-width: 112px;
    }
    .leads__info {
      .card__lead {
        font-weight: 700;
      }
    }
    .leader__info {
      h2 {
        font-weight: 700;
      }
      h3 {
        font-weight: 700;
      }
      .copy {
        font-weight: 200;
      }
    }
  }
  .copy__link {
    font-weight: 200;
  }
}
@media only screen and (max-width: 1445px) {
  .network .leader__info {
    &.active:hover .lead__delete {
      top: 28px;
    }
    .lead__create__link span.video__create_link {
      position: absolute;
      left: -11px;
      top: 18px;
    }
  }
}
@media only screen and (max-width: 570px) {
  .network .card__leader {
    width: calc(50%);
  }
}
@media only screen and (max-width: 450px) {
  .network .card__leader {
    width: calc(100%);
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/networkUser.vue